import type { Principal } from "@knowledge/sync";
import { api } from "./http";
let pending: Promise<{ principal: Principal }> | undefined;
let started = 0;
/** Share the early discovery request with the lazy workspace, never cache a session indefinitely. */
export function initialSession() {
  if (!pending || Date.now() - started > 10000) {
    started = Date.now();
    const request = api<{ principal: Principal }>("/api/session");
    pending = request;
    void request.catch(() => {
      if (pending === request) pending = undefined;
    });
  }
  return pending;
}
export function forgetInitialSession() {
  pending = undefined;
}
